import React from "react";
import PropTypes from "prop-types";

const HighchartsReact = window.HighchartsReact;
import mauritiusMapData from "../data/mauritius";

const MauritiusMap = ({ highcharts, selectedCountry, selectCountry, tariffValueColor }) => {

  const mapOptions = {
    chart: {
      height: 100,
      width: 100,
      style: {
        fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif"
      },
      borderColor: selectedCountry === "mu" ? "#c84646" : "#bdc2bf",
      borderWidth: 3
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false
    },
    title: {
      text: ""
    },
    legend: {
      enabled: false
    },
    series: [{
      mapData: mauritiusMapData,
      data: [],
      nullColor: tariffValueColor,
      borderColor: "#4cb563",
      borderWidth: 0.1,
    }]
  };

  return (
    <div className="mauritius-wrapper">
      <div className="title" style={{ color: tariffValueColor }}>Mauritius</div>
      <div onClick={() => selectCountry("mu")} >
        <HighchartsReact
          highcharts={highcharts}
          constructorType={"mapChart"}
          options={mapOptions}
          key={selectedCountry}
        />
      </div>
    </div>
  );
};

export default MauritiusMap;

MauritiusMap.propTypes = {
  highcharts: PropTypes.shape({
    charts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  selectedCountry: PropTypes.string.isRequired,
  selectCountry: PropTypes.func.isRequired,
  tariffValueColor: PropTypes.string.isRequired,
};
